export enum LocalStorageKeyType {
  Test = 'test',
  WelcomeFieldAi = 'welcome-field-ai',
  SidebarNavOptIn = 'sidebar-nav-opt-in',
  SidebarNavCollapsed = 'sidebar-nav-collapsed',
  DocumentPreferences = 'document-preferences',
  ClmeRecentWorkflowIds = 'clme-recent-workflow-ids',
  ClmeRequestFieldsPreferences = 'clme-request-fields-preferences',
  EntityFieldsPreferences = 'entity-fields-preferences',
  ClmeFormSectionsPanelCollapsed = 'clme-form-sections-panel-collapsed',
  ClmeBuilderAiPlacement = 'clme-builder-ai-placement',
  DetailsPanelPreferences = 'details-panel-preferences',
  EntityMembershipCollapsedSections = 'entity-membership-collapsed-sections',
}
